/* eslint-disable no-console */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import {
  DashboardLayout,
  StyledTabs,
  OverlayDashboard,
  DropDownCompanayContainer,
  DownloadWrapper,
  DropdownWrapper
} from "./styles";
import EngagementSectionV2 from "../EngagementSectionV2";
import FitnessTab from "../FitnessTabV2";
import ChampionSectionV2 from "../ChampionSectionV2";
import Waiting from "../Waiting";
import StyledDropDown from "../DropDown";
import NameHeader from "../NameHeader/NameHeaderCompanyDashboard";
import {
  fetchDashBoardAPI,
  fetchFitnessAPI,
  fetchChampionAPI,
  fetchReportTabAction,
  setSelectedYear,
  fetchAdminAPI,
  updateCompanyInfo,
  fetchCompanyInfo,
} from "../../redux/actions";
import EngagementCSVModal from "../EngagementCSVModal";
import WellnessAdmins from "../WellnessAdmins";
import CompanyInfoUpdate from "./companyInfoPopupMain";
import { DownloadIconBranding, DownloadReportIcon } from "../../utils/icons";
import HoverButton from "../common/HoverButton";
import { Dropdown } from "react-bootstrap";
import { RecipeCSVdownload, FitnessvideoCSVdownload, ArticleCSVdownload } from '../../redux/constants/apiConstants';
import { toast } from "react-toastify";
import { BASE_URL } from "../../utils/config";
import CSVList from '../AttendeesModal/CSVList';
import { BrandingTabContainer, BrandingTab } from '../common/commonStyles';
import { CommonFilterDropdown } from '../common/CommonYearFilter/CommonYearFilter';
import Manager from '../ManagerTab/index'

const RecipeHeaders = [
  { label: "Name", key: "name" },
  { label: "Video URL", key: "video_url" },
  { label: "Total Time(Mins)", key: "total_time" },
  { label: "Meal Type", key: "meal_type" },
  { label: "Cook Time(Mins)", key: "cook_time" },
  { label: "Prep Time(Mins)", key: "prep_time" },
  { label: "Category Tags", key: "category_tags" },
  { label: "Last Updated", key: "last_updated" }
];

const FitnessHeaders = [
  { label: "Title", key: "title" },
  { label: "Video Url", key: "video_url" },
  { label: "Fitness Level", key: "fitness_level" },
  { label: "Muscle Group", key: "muscle_group" },
  { label: "Video Category", key: "video_category" },
  { label: "Last Updated", key: "Last Updated" },
];

const ArticleHeaders = [
  { label: "Title", key: "title" },
  { label: "Category Name", key: "category_name" },
  { label: "Last Updated", key: "Last_Updated" }
];
class CompanyDashBoard extends Component {
  constructor(props) {
    super(props);

    const selectedCompanyJSON = localStorage.getItem('selectedCompany');
    const localCompanyInfo = JSON.parse(selectedCompanyJSON);
    const localCompanyId = localCompanyInfo?.id;
    const localCompanyName = localCompanyInfo?.name;

    this.state = {
      companyId: localCompanyId ? parseInt(localCompanyId, 10) : props.companyInfo.id,
      companyName: localCompanyName ? localCompanyName : props.companyInfo.name,
      printEnrolledUsers: false,
      selectedTabId: 1,
      showCompanyInfoPopup: false,
      showArticle: false,
      showFitnessVideo: false,
      showRecipeVideo: false,
      getRecipeData:[],
      getFitnessData: [],
      getArticleData: []
    };
  }

  componentDidMount() {
    const { fetchDashBoardAPI } = this.props;
    let currentYear = new Date().getFullYear();
    fetchDashBoardAPI(this.state.companyId, currentYear);
  }

  downloadReportsAPI=()=>{
    this.fetchRecipeData();
    this.fetchFitnessData();
    this.fetchArticleData();
  }

  fetchArticleData = async () => {
    const AuthToken = localStorage.getItem("AUTH_TOKEN");
    let url = BASE_URL + ArticleCSVdownload;
    await fetch(url, { method: "GET", headers: { AUTHTOKEN: AuthToken },credentials:'include',
      withCredentials: true })
      .then((res) => {
        res
          .json()
          .then((data) => {
            if(data.status === 'success'){
              this.setState({getArticleData: data.data[0] }
              );
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  fetchRecipeData= async () => {
    const AuthToken = localStorage.getItem("AUTH_TOKEN");
    let url = BASE_URL + RecipeCSVdownload;
    await fetch(url, { method: "GET", headers: { AUTHTOKEN: AuthToken },    
      credentials:'include',
      withCredentials: true })
      .then((res) => {
        res
          .json()
          .then((data) => {
            if(data.status === 'success'){
              this.setState({getRecipeData: data.data }
              );
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  fetchFitnessData = async () => {
    const AuthToken = localStorage.getItem("AUTH_TOKEN");
    let url = BASE_URL + FitnessvideoCSVdownload;
    await fetch(url, { method: "GET", headers: { AUTHTOKEN: AuthToken },credentials:'include',
      withCredentials: true })
      .then((res) => {
        res
          .json()
          .then((data) => {
            if(data.status === 'success'){
              this.setState({getFitnessData: data.data[0] }
              );
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  printRecipeAction = () => {
    let data = [];
    const { getRecipeData } = this.state;
    getRecipeData && getRecipeData?.length > 0 && getRecipeData.map((best) => {
      let obj = {};
      obj['name'] = best['name'];
      obj['video_url'] = best['video_url'];
      obj['total_time'] = best['total_time'];
      obj['last_updated']=best['last_updated']
      obj['meal_type']=best['meal_type']
      obj['cook_time']=best['cook_time']
      obj['prep_time']=best['prep_time']
      obj['category_tags']=best.category_tags.map((data)=>(data?.recipe_tag))
      data.push(obj);
    });
    return data;
  };

  printFitnessAction = () => {
    let data = [];
    const { getFitnessData } = this.state;
    getFitnessData && getFitnessData?.length > 0 && getFitnessData.map((best) => {
      let obj = {};
      obj['title'] = best['title'];
      obj['video_url'] = best['video_url'];
      obj['fitness_level'] = best['fitness_level'];
      obj['muscle_group']=best['muscle_group']
      obj['Last Updated']=best['Last Updated']
      obj['video_category']=best['video_category']
      data.push(obj);
    });
    return data;
  };

  printArticleAction = () => {
    let data = [];
    const { getArticleData } = this.state;
    getArticleData && getArticleData?.length > 0 && getArticleData.map((best) => {
      let obj = {};
      obj['title'] = best['title'];
      obj['Last_Updated'] = best['Last_Updated'];
      obj['category_name'] = best['category_name'];
      data.push(obj);
    });
    return data;
  };

  getMenuItems = () => {
    const { companies } = this.props;
    return companies && companies.map((company) => company.company_name);
  };

  onSelect = (value) => {
    const {
      companies,
      setCompany,
      fetchDashBoardAPI,
      fetchFitnessAPI,
      fetchChampionAPI,
      fetchAdminAPI,
      companyBrandingCallBack,
      fetchCompanyInfo,
    } = this.props;
    const id = companies.filter((company) => company.company_name === value)[0]
      .id;
    const comapanyStartDate = companies.filter(
      (company) => company.company_name === value
    )[0].company_start_date;
    const biometricStatus = companies.filter(
      (company) => company.company_name === value
    )[0].show_biometric;

    const selectedCompany = {
      id: id,
      name: value,
      companyStartDate: comapanyStartDate,
      showBiometricStatus: biometricStatus
    };
  
    localStorage.setItem('selectedCompany', JSON.stringify(selectedCompany));

    setCompany(id, value, comapanyStartDate, biometricStatus);
    fetchCompanyInfo(id);
    companyBrandingCallBack(id);
    let currentYear = new Date().getFullYear();
    this.setState(
      {
        companyId: id,
        companyName: value
      },
      () => {
        this.state.selectedTabId === 1
          ? fetchDashBoardAPI(this.state.companyId, currentYear)
          : this.state.selectedTabId === 2
            ? fetchFitnessAPI(this.state.companyId, currentYear)
            : this.state.selectedTabId === 3
              ? fetchChampionAPI(this.state.companyId)
              : fetchAdminAPI(this.state.companyId);
      }
    );
  };
  updatePrintState = () => {
    this.setState((prevState) => ({
      printEnrolledUsers: !prevState.printEnrolledUsers,
    }));
  };

  toggleTab = (active) => {
    const {
      fetchFitnessAPI,
      fetchChampionAPI,
      fetchAdminAPI,
      selectedYearInfo,
      fetchDashBoardAPI,
    } = this.props;
    this.setState({ selectedTabId: active });
    active === 1
      ? fetchDashBoardAPI(this.state.companyId, selectedYearInfo)
      : active === 2
        ? fetchFitnessAPI(this.state.companyId, selectedYearInfo)
        : active === 3
          ? fetchChampionAPI(this.state.companyId)
          : fetchAdminAPI(this.state.companyId);
  };
  updateDropdown = (year) => {
    const {
      fetchFitnessAPI,
      fetchReportTabAction,
      fetchDashBoardAPI,
      setSelectedYear,
    } = this.props;
    const { companyId, selectedTabId } = this.state;
    fetchReportTabAction(companyId, year);
    setSelectedYear(year);
    selectedTabId === 1
      ? fetchDashBoardAPI(companyId, year)
      : selectedTabId === 2
        ? fetchFitnessAPI(companyId, year)
        : null;
  };

  showCompanyInfoPopup = (id) => {
    this.setState(
      () => ({
        showCompanyInfoPopup: true,
      }),
      () => this.props.fetchCompanyInfo(id)
    );
  };

  hideCompanyInfoPopup = () => {
    this.setState({
      showCompanyInfoPopup: false,
    });
  };

  updateInformationApi = (obj) => {
    this.setState(
      () => ({
        showCompanyInfoPopup: false,
      }),
      () => this.props.updateCompanyInfo(obj)
    );
  };

  downloadRecipeList = (bool) => {
    this.setState({
      showRecipeVideo: bool
    })
  };

  downloadFitnessList = (bool) => {
    this.setState({
      showFitnessVideo: bool
    })
  };

  downloadArticleList = (bool) => {
    this.setState({
      showArticle: bool
    })
  };

  render() {
    const {
      csvButton,
      networkError,
      wellnessChampions,
      wellnessAdmin,
      topChallenges,
      topEvents,
      newUsers,
      leastActiveUsers,
      mostActiveUsers,
      topDevices,
      fitnessGoals,
      topActivities,
      weekExercise,
      wellnessInitiatives,
      companyInitiatives,
      employeeCount,
      role,
      companyInfo,
      enrolledUsers,
      activeMinutes,
      eligibleEmployee,
      history,
      selectedYearInfo,
      yearList,
      fitnessTabLoading,
      fitnessUsers,
      showCompaniesDropdown,
      DownloadFileAccess,
      companyDetailsInfo,
      colorInfo,
      companyInfoData,
      isAccountManager,
      brandingColor
    } = this.props;
    const {
      companyId,
      printEnrolledUsers,
      selectedTabId,
      showCompanyInfoPopup,
      showFitnessVideo,
      showRecipeVideo,
      showArticle,
      getRecipeData,
      getFitnessData,
      getArticleData
    } = this.state;
    let getColor = brandingColor ? brandingColor : "rgba(243, 122, 101, 1)"
    const fileTitle = (
      companyInfo && companyInfo.name !== null ? companyInfo.name : ""
    ).replace(/ /g, "_");
    if (networkError) {
      return <Waiting />;
    }
    return (
      <OverlayDashboard showOverlay={employeeCount && csvButton}>
        {printEnrolledUsers ? "" : !!employeeCount && csvButton && <Waiting />}
        <DashboardLayout>
          <NameHeader />
          <BrandingTabContainer style={{maxWidth:"1246px", margin:"20px auto 20px auto"}} gap="16px" background="#FEFEFE99">
            <div className='wrapper'>
              <BrandingTab active={this.state.selectedTabId===1} background={getColor ? getColor : "#0b4170"} backgroundDefault="transparent" onClick={()=>this.toggleTab(1)}>
                Engagement
              </BrandingTab>
              <BrandingTab active={this.state.selectedTabId===2} background={getColor ? getColor : "#0b4170"} backgroundDefault="transparent" onClick={()=>this.toggleTab(2)}>
                Fitness
              </BrandingTab>
              <BrandingTab active={this.state.selectedTabId===5} background={getColor ? getColor : "#0b4170"} backgroundDefault="transparent" onClick={()=>this.toggleTab(5)}>
                Manager
              </BrandingTab>
              {/* <BrandingTab active={this.state.selectedTabId===3} background={getColor ? getColor : "#0b4170"} backgroundDefault="transparent" onClick={()=>this.toggleTab(3)}>
                Champions
              </BrandingTab> */}
              {/* <BrandingTab active={this.state.selectedTabId===4} background={getColor ? getColor : "#0b4170"} backgroundDefault="transparent" onClick={()=>this.toggleTab(4)}>
                Admins
              </BrandingTab> */}
            </div>
            <div className="rightSection">
              {DownloadFileAccess && <div>
                <HoverButton
                  title={"Download"}
                  svgPath={<DownloadIconBranding />}
                  activeColor={"#F37A65"}
                  inActiveColor={"#F37A65"}
                  backgroundColor={"transparent"}
                  backgroundColorActive={"#F37A65"}
                  onClick={() => {this.updatePrintState();}}
                  width={"24px"}
                  height={"24px"}
                  fillOpacity={1}
                />
              </div>}
              {role == "ADMIN"&&<div style={{padding:"10px 0"}}>
                {(this.state.selectedTabId === 3)? false
                  :(
                    <DropdownWrapper><div style={{padding: "0px"}}>
                      <Dropdown>
                        <Dropdown.Toggle>
                          <div style={{}}>
                            <DownloadWrapper admin={role == "ADMIN"}>
                              <HoverButton
                                width={"24px"}
                                height={"24px"}
                                title={"Download"}
                                fillOpacity={1}
                                activeColor={"#F37A65"}
                                inActiveColor={"#F37A65"}
                                backgroundColor={"transparent"}
                                backgroundColorActive={"#F37A65"}
                                svgPath={<DownloadReportIcon />}
                                onClick={()=>this.downloadReportsAPI()}
                              />
                            </DownloadWrapper>
                          </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={()=>this.downloadArticleList(true)} >
                            Download All Article Details
                          </Dropdown.Item>
                          <hr/>
                          <Dropdown.Item onClick={()=>this.downloadFitnessList(true)} >
                            Download All Fitness Video Details
                          </Dropdown.Item>
                          <hr/>
                          <Dropdown.Item onClick={()=>this.downloadRecipeList(true)} >
                            Download All Recipe Details
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div></DropdownWrapper>
                  )}
              </div>}
              {(this.state.selectedTabId === 1 ||this.state.selectedTabId === 2) &&<div>
                <CommonFilterDropdown
                  options={yearList}
                  selectedOption={selectedYearInfo}
                  setSelectedOption={this.updateDropdown}
                  dropdownHeight={"auto"}
                />
              </div>}
              {(showCompaniesDropdown||isAccountManager) && (
                <DropDownCompanayContainer width={"unset"}>
                  <StyledDropDown
                    title={this.state.companyName || get(companyInfo, "name", "Filter companies")}
                    MenuItems={this.getMenuItems()}
                    isCompanyDashboard={true}
                    onSelect={this.onSelect}
                    style={{ margin: "0px", width: "100%" }}
                  />
                </DropDownCompanayContainer>
              )}
            </div>
          </BrandingTabContainer>
          {this.state.selectedTabId === 1 ? (
            <EngagementSectionV2
              companyId={companyInfo.id}
              wellnessChampions={wellnessChampions}
              topChallenges={topChallenges}
              topEvents={topEvents}
              newUsers={newUsers}
              wellnessInitiatives={wellnessInitiatives}
              companyInitiatives={companyInitiatives}
              employeeCount={employeeCount || 0}
              updatePrintState={this.updatePrintState}
              eligibleEmployee={eligibleEmployee}
              selectedYearInfo={selectedYearInfo}
              history={history}
              role = {role}
              showCompanyInfoPopup={this.showCompanyInfoPopup}
              hideCompanyInfoPopup={this.hideCompanyInfoPopup}
            />
          ) :this.state.selectedTabId === 2 ? (
            <FitnessTab
              mostActiveUsers={mostActiveUsers}
              leastActiveUsers={leastActiveUsers}
              fitnessGoals={fitnessGoals}
              topDevices={topDevices}
              companyId={companyId}
              topActivities={topActivities}
              weekExercise={weekExercise}
              activeMinutes={activeMinutes}
              selectedYearInfo={selectedYearInfo}
              fitnessTabLoading={fitnessTabLoading}
              yearList={yearList}
            />):
            this.state.selectedTabId === 3 ? (
              <ChampionSectionV2 wellnessChampions={wellnessChampions} />):
              this.state.selectedTabId===4?
                <WellnessAdmins wellnessAdmin={wellnessAdmin} />:
                <Manager companyId={companyId} history={this.props.history}/>
          }
          {printEnrolledUsers && (
            <EngagementCSVModal
              showModal={printEnrolledUsers}
              onHide={this.updatePrintState}
              enrolledUsers={enrolledUsers}
              fileTitle={fileTitle}
              yearList={yearList}
              companyId={companyId}
              csvButton={csvButton}
              role={role}
              selectedTabId={selectedTabId}
              fitnessUsers={fitnessUsers}
              StyledTabs={StyledTabs}
            />
          )}
          {showCompanyInfoPopup && (
            <CompanyInfoUpdate
              show={showCompanyInfoPopup}
              hidePopup={this.hideCompanyInfoPopup}
              updateInformationApi={this.updateInformationApi}
              companyId={companyId}
              companyName={
                companyDetailsInfo && companyDetailsInfo.company_name
              }
              companyLogo={companyDetailsInfo && companyDetailsInfo.header_logo}
              companyColor={
                colorInfo &&
                colorInfo?.color_branding &&
                colorInfo?.color_branding[1]?.color_code
              }
              companyInfoData={companyInfoData}
            />
          )}
        </DashboardLayout>
        {((showFitnessVideo&&getFitnessData?.length>0) ||(showRecipeVideo&&getRecipeData?.length>0)||(showArticle&&getArticleData?.length>0))&&
          <CSVList
            Title={showFitnessVideo?"List of All Fitness Videos":showArticle?"List of All Articles": "List of All Recipe Videos"}
            removeCSVData={showFitnessVideo?this.downloadFitnessList:showArticle?this.downloadArticleList:this.downloadRecipeList}
            headers={showFitnessVideo?FitnessHeaders:showArticle?ArticleHeaders:RecipeHeaders}
            data={showFitnessVideo?this.printFitnessAction():showArticle?this.printArticleAction(): this.printRecipeAction()}
          />
        }
      </OverlayDashboard>
    );
  }
}
CompanyDashBoard.defaultProps = {
  companyInfo: { id: 1, name: "" },
};
CompanyDashBoard.propTypes = {
  wellnessChampions: PropTypes.array,
  wellnessAdmin: PropTypes.array,
  networkError: PropTypes.string,
  companies: PropTypes.array,
  companyInfo: PropTypes.object.isRequired,
  setCompany: PropTypes.func.isRequired,
  topChallenges: PropTypes.array,
  topEvents: PropTypes.array,
  newUsers: PropTypes.array,
  mostActiveUsers: PropTypes.array,
  leastActiveUsers: PropTypes.array,
  fitnessGoals: PropTypes.array,
  topDevices: PropTypes.array,
  topActivities: PropTypes.array,
  weekExercise: PropTypes.object,
  wellnessInitiatives: PropTypes.array,
  companyInitiatives: PropTypes.array,
  role: PropTypes.string.isRequired,
  employeeCount: PropTypes.number,
  history: PropTypes.object,
  fetchDashBoardAPI: PropTypes.func,
  fetchFitnessAPI: PropTypes.func,
  fetchChampionAPI: PropTypes.func,
  fetchAdminAPI: PropTypes.func,
  enrolledUsers: PropTypes.array,
  fitnessUsers: PropTypes.array,
  csvButton: PropTypes.bool,
  activeMinutes: PropTypes.object,
  eligibleEmployee: PropTypes.any,
  selectedYearInfo: PropTypes.number,
  yearList: PropTypes.array,
  fitnessTabLoading: PropTypes.bool,
  fetchReportTabAction: PropTypes.func,
  groupSummaryYearList: PropTypes.array,
  setSelectedYear: PropTypes.func,
  showCompaniesDropdown: PropTypes.bool,
  DownloadFileAccess: PropTypes.bool,
  companyBrandingCallBack: PropTypes.func,
  updateCompanyInfo: PropTypes.func,
  companyDetailsInfo: PropTypes.object,
  colorInfo: PropTypes.object,
  fetchCompanyInfo: PropTypes.func,
  companyInfoData: PropTypes.object,
  localCompanyId: PropTypes.number,
  localCompanyName: PropTypes.string,
  isAccountManager: PropTypes.bool,
  brandingColor:PropTypes.string
};

const mapStateToProps = (state) => ({
  wellnessChampions: state.companyDashboard.wellnessChampions,
  wellnessAdmin: state.companyDashboard.wellnessAdmin,
  networkError: state.companyDashboard.networkError,
  topChallenges: state.companyDashboard.topChallenges,
  topEvents: state.companyDashboard.topEvents,
  newUsers: state.companyDashboard.newUsers,
  mostActiveUsers: state.companyDashboard.mostActiveUsers,
  leastActiveUsers: state.companyDashboard.leastActiveUsers,
  fitnessGoals: state.companyDashboard.fitnessGoals,
  topDevices: state.companyDashboard.topDevices,
  topActivities: state.companyDashboard.topActivities,
  weekExercise: state.companyDashboard.weekExercise,
  wellnessInitiatives: state.companyDashboard.wellnessInitiatives,
  companyInitiatives: state.companyDashboard.companyInitiatives,
  employeeCount: state.companyDashboard.employeeCount,
  enrolledUsers: state.companyDashboard.enrolledUsers,
  fitnessUsers: state.companyDashboard.fitnessUsers,
  csvButton: state.companyDashboard.csvButton,
  activeMinutes: state.companyDashboard.activeMinutes,
  eligibleEmployee: state.companyDashboard.eligibleEmployee,
  selectedYearInfo: state.companyDashboard.selectedYearInfo,
  fitnessTabLoading: state.companyDashboard.fitnessTabLoading,
  companyDetailsInfo: state.profileData.companyDetails,
  colorInfo: state.wellnessDashboard.companyBrandingDetails,
  companyInfoData: state.companyDashboard.companyInfoData,
  brandingColor:state.wellnessDashboard.brandingColor
});

const mapDispatchToProps = (dispatch) => ({
  fetchDashBoardAPI: (id, year) => dispatch(fetchDashBoardAPI(id, year)),
  fetchFitnessAPI: (id, year) => dispatch(fetchFitnessAPI(id, year)),
  fetchChampionAPI: (id) => dispatch(fetchChampionAPI(id)),
  fetchAdminAPI: (id) => dispatch(fetchAdminAPI(id)),
  fetchReportTabAction: (id, year) => dispatch(fetchReportTabAction(id, year)),
  setSelectedYear: (year) => dispatch(setSelectedYear(year)),
  updateCompanyInfo: (obj) => dispatch(updateCompanyInfo(obj)),
  fetchCompanyInfo: (id) => dispatch(fetchCompanyInfo(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDashBoard);